import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import EquipmentManagementCard from "./EquipmentManagementCard";
import axios from "axios";
import API from "../helpers/api";
import {
  getEquipmentList,
  getEquipmentDetails,
  getMakeAndModel,
  getEquipmentMakeModelAndType,
  getEquipmentMakeModelDetails,
} from "../Actions/EquipmentManagementAPI";

import {
  getCategoryList,
  getEquipmentTypeList,
  getEquipmentNameListAndId,
  getMakeList,
  getModelsList,
  getApplicableSeviceTypewithIdList,
} from "../Actions/helpersAPI";
import { event } from "jquery";
import { getServiceTypeList } from "../Actions/CommonAPI";
import $ from "jquery";
import { ThreeSixty } from "@material-ui/icons";
import { toast } from "react-toastify";


const SearchItems = {
  EquipmentId: 0,
  Equipment: "",
  MakeId: 0,
  ModelId: 0,
  Make: "",
  Model: "",
  ServiceType: "",
  EquipmentType: "",
  EquipmentCategoryType: '',
  EquipmentCategoryId: 0,
  Category: "",
  ServiceTypeId: 0,
  capacity: "",
  PageNumber: 1,
  PageSize: 20,
};


class EquipmentManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAlert: false,
      searchData: {
        EquipmentId: 0,
        Equipment: "",
        MakeId: 0,
        ModelId: 0,
        Make: "",
        Model: "",
        ServiceType: "",
        EquipmentType: "",
        EquipmentCategoryType: '',
        EquipmentCategoryId: 0,
        Category: "",
        ServiceTypeId: 0,
        capacity: "",
        PageNumber: 1,
        PageSize: 20,
      },
      applicableServiceType: [],
      selectedEquipments: [],
      selectedMakes: [],
      selectedModels: [],
      selectedServiceType: [],
      selectedEquipmentTypes: [],
      equipment: "",
      make: "",
      model: "",
      service: "",
      openEquipment: false,
      openType: false,
      openCategoary: false,
      openMake: false,
      openModel: false,
      openServiceType: false,
      equipemntConfigTypeList: [],
    };
    this.SearchEquipment = this.SearchEquipment.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    // this.renderEquipmentTitle = this.renderEquipmentTitle.bind(this);
    // this.renderCategoryTitle = this.renderCategoryTitle.bind(this);
    //this.renderTypeTitle = this.renderTypeTitle.bind(this);
    // this.renderMakeTitle = this.renderMakeTitle.bind(this);
    // this.renderModelTitle = this.renderModelTitle.bind(this);
    // this.renderServiceTypeTitle = this.renderServiceTypeTitle.bind(this);
  }

  componentDidMount() {
    const { dispatch,t } = this.props;
    let data = {
      equipmentId: 0,
      makename: "",
      modelname: "",
    };
    this.setState({});
    if (this.props.equipmentSearch) {
      this.state.searchData = this.props.equipmentSearch;
    }
    dispatch(getEquipmentMakeModelAndType(data));
    dispatch(getEquipmentList(this.state.searchData));
    this.getEquipmentType()
    // this.ClearInput();
    dispatch({ type: "SubBannerTitle", data: "Equipment Management" });
    let searchitem = this.state.searchData;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;
      // if (
      //   // searchitem.EquipmentId ||
      //   // searchitem.EquipmentType ||
      //   // searchitem.Category ||
      //   // searchitem.ServiceTypeId ||
      //   // searchitem.MakeId ||
      //   // searchitem.ModelId ||
      //   // searchitem.capacity
      //   _this.verifySearchItems()
      // ) {
      if (keycode === 13) {
        if (_this.verifySearchItems()) {
          _this.SearchEquipment(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  SearchEquipment(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch({ type: "equipmentSearch", data: this.state.searchData });
    dispatch(getEquipmentList(this.state.searchData));
  }
  // const searchData = {
  //   EquipmentId: 0,
  //   Equipment: "",
  //   MakeId: 0,
  //   ModelId: 0,
  //   Make: "",
  //   Model: "",
  //   ServiceType: "",
  //   EquipmentType: "",
  //   EquipmentCategoryType: '',
  //   EquipmentCategoryId: 0,
  //   Category: "",
  //   ServiceTypeId: 0,
  //   capacity: "",
  //   PageNumber: 1,
  //   PageSize: 20,
  // }

  verifySearchItems = () => {
    let flag = true;
    const search = this.state.searchData;
    if (search.EquipmentId == 0 && search.EquipmentType == "" && search.Category == "" && search.capacity == "" && search.MakeId == 0 && search.ModelId == 0 && search.ServiceTypeId == 0 && search.EquipmentCategoryId == 0) {
      flag = false;
    }
    return flag;
  }

  SearchEquipment1(pgno) {
    if (this.verifySearchItems()) {
      const { dispatch } = this.props;
      this.state.searchData.PageNumber = pgno;
      dispatch({ type: "equipmentSearch", data: this.state.searchData });
      dispatch(getEquipmentList(this.state.searchData));
    }
    else {
      toast.success("Please select atleast one value", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  ClearInput() {
    
    let param = { ...SearchItems }
    this.state.selectedServiceType = [];
    // this.state.searchData.EquipmentId = 0;
    // this.state.searchData.EquipmentType = "";
    // this.state.searchData.Category = "";
    // this.state.searchData.Equipment = "";
    // this.state.searchData.Model = "";
    // this.state.searchData.Make = "";
    // this.state.searchData.ServiceType = "";
    // this.state.searchData.ServiceTypeId = 0;
    // this.state.searchData.MakeId = 0;
    // this.state.searchData.ModelId = 0;
    // this.state.searchData.capacity = "";
    this.state.selectedEquipments = [];
    // this.state.searchData.EquipmentCategoryId = 0;
    this.state.selectedEquipmentTypes = [];
    this.state.selectedMakes = [];
    this.state.selectedModels = [];
    this.setState({
      annual: false,
      biannual: false,
      fiveyearly: false,
      tenyearly: false,
      applicableServiceType: [],
      searchData: param,

    }, () => {
      this.props.dispatch(getEquipmentList(this.state.searchData));
    });
    let data = {
      equipment: 0,
      make: "",
      model: "",
    };
    this.props.dispatch({ type: "equipmentSearch", data: "" });
    this.props.dispatch(getEquipmentList(this.state.searchData));
    this.props.dispatch(getEquipmentMakeModelAndType(data));
  }

  eyeclick(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "ShowSidePan", data: true });
    history.push(`/Home/EquipmentManagement/${item.equipmentId}`);
    dispatch(getEquipmentDetails(item.equipmentId));
    dispatch(getEquipmentMakeModelDetails(item.equipmentId));
    window.scrollTo(0, 0);
  }

  NewitemNav() {
    this.props.dispatch({ type: "EQUIPMENT MANAGEMENT", data: false });
    this.props.dispatch({
      type: "AttchmentUploaded",
      data: "",
    });
    this.props.dispatch({
      type: "GAttchmentUploaded",
      data: "",
    });
    this.props.dispatch({
      type: "EquipManualAttchmentUploaded",
      data: "",
    });
    this.props.history.push("/Home/AddNewEquipment");
  }
  onEquipmentChange = (event, id, values) => {
    if (values) {
      this.state.selectedEquipments = values;
      this.state.searchData.EquipmentId = id;
      this.state.searchData.Equipment = values.name;
      this.setState({}, () => {
        console.log(this.state.selectedEquipments, this.state.searchData);
      });
      let data = {
        equipment: this.state.searchData.EquipmentId,
        make: this.state.searchData.Make,
        model: this.state.searchData.Model,
      };
      this.props.dispatch(getEquipmentMakeModelAndType(data));
    }
    else {
      this.state.selectedEquipments = [];
      this.state.searchData.EquipmentId = 0;
      this.state.searchData.Equipment = "";
      this.setState({});
      let data = {
        equipment: 0,
        make: this.state.searchData.Make,
        model: this.state.searchData.Model,
      };
      this.props.dispatch(getEquipmentMakeModelAndType(data));
    }
  };
  onTypeChange = (event, value) => {
    // if (value) {
    this.state.searchData.EquipmentType = value ? value : "";
    this.setState({});
    // }
  };
  onEquipmentTypeChange = (event, id, values) => {
    // if (values) {
    this.state.selectedEquipmentTypes = values ? values : [];
    this.state.searchData.EquipmentCategoryId = id ? id : 0;
    this.setState({});
    // }
  };
  onCategoryChange = (event, values) => {
    if (values) {
      this.state.searchData.Category = values;
      this.setState({});
    }
    else {
      this.state.searchData.Category = "";
      this.setState({});
    }
  };
  onMakeChange = (event, id, values) => {
    if (values) {
      this.state.selectedMakes = values;
      this.state.searchData.MakeId = id;
      this.setState({});
      let data = {
        equipment: this.state.searchData.EquipmentId,
        make: this.state.searchData.Make,
        model: this.state.searchData.Model,
      };
      this.props.dispatch(getEquipmentMakeModelAndType(data));
    }
    else {
      this.state.selectedMakes = "";
      this.state.searchData.MakeId = 0;
      this.setState({});
    }
    let data = {
      equipment: this.state.searchData.EquipmentId,
      make: this.state.searchData.Make,
      model: "",
    };
    this.props.dispatch(getEquipmentMakeModelAndType(data));
  };
  onModelsChange = (event, id, values) => {
    if (values) {
      this.state.selectedModels = values;
      this.state.searchData.ModelId = id;
      this.setState({});
      let data = {
        equipment: this.state.searchData.EquipmentId,
        make: this.state.searchData.Make,
        model: this.state.searchData.Model,
      };
      this.props.dispatch(getEquipmentMakeModelAndType(data));
    }
    else {
      this.state.selectedModels = [];
      this.state.searchData.ModelId = 0;
      this.setState({});
      let data = {
        equipment: this.state.searchData.EquipmentId,
        make: this.state.searchData.Make,
        model: "",
      };
      this.props.dispatch(getEquipmentMakeModelAndType(data));
    }
  };
  onServiceTypeChanges = (event, id, values) => {
    if (values) {
      this.state.selectedServiceType = values;
      this.state.searchData.ServiceTypeId = id;
      this.setState({});
    }
    else {
      this.state.selectedServiceType = "";
      this.state.searchData.ServiceTypeId = 0;
      this.setState({});
    }
  };
  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "annually") {
      if (e.target.checked) this.state.applicableServiceType.push("annually");
      else
        this.state.applicableServiceType =
          this.state.applicableServiceType.filter((r) => r !== "annually");
      this.setState({ annually: e.target.checked });
    } else if (nodeName === "biannually") {
      if (e.target.checked) this.state.applicableServiceType.push("biannually");
      else
        this.state.applicableServiceType =
          this.state.applicableServiceType.filter((r) => r !== "biannually");
      this.setState({ biannually: e.target.checked });
    } else if (nodeName === "fiveyearly") {
      if (e.target.checked) this.state.applicableServiceType.push("fiveyearly");
      else
        this.state.applicableServiceType =
          this.state.applicableServiceType.filter((r) => r !== "fiveyearly");
      this.setState({ fiveyearly: e.target.checked });
    } else if (nodeName === "tenyearly") {
      if (e.target.checked) this.state.applicableServiceType.push("tenyearly");
      else
        this.state.applicableServiceType =
          this.state.applicableServiceType.filter((r) => r !== "tenyearly");
      this.setState({ tenyearly: e.target.checked });
    } else {
      this.state.searchData[nodeName] = e.target.value;
    }
    this.setState({});
  }
  handleInputChanges(e, field) {
    this.state.searchData[field] = e.target.value;
    this.setState({});
  }
  /* handleSelectChange(value, field, id, fieldId) {
    this.state.searchData[field] = value;
    this.state.searchData[fieldId] = id;
    this.setState({});
    if (
      fieldId === "EquipmentId" ||
      fieldId === "MakeId" ||
      fieldId === "ModelId"
    ) {
      let data = {
        equipment: this.state.searchData.EquipmentId,
        make: this.state.searchData.Make,
        model: this.state.searchData.Model,
      };
      this.props.dispatch(getEquipmentMakeModelAndType(data));
    }
  } */

  /*   renderEquipmentTitle(state, val) {
    return state?.name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderCategoryTitle(state, val) {
    return state?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderTypeTitle(state, val) {
    return state?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderMakeTitle(state, val) {
    return state?.name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderModelTitle(state, val) {
    return state?.name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderServiceTypeTitle(state, val) {
    return state?.name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  } */
  getEquipmentType = () => {
    // let url = `${API.equipmentLookups}?lookupType=equipmenttype`;
    let url = `${API.equipmentLookups}?lookupType=${"EquipmentCategoryType"}`;
    axios.get(url).then((response) => {
      console.log(response.data);

      this.setState({ equipemntConfigTypeList: response.data });
    });
  }

  render() {
    const {
      EquipmentList,
      EquipmentTypeList,
      EquipmentDropdownList,
      CategoryList,
      showSidePane,
      MakeList,
      DropdownModelList,
      DropdownServiceTypeList,
      applicableServiceTypeList,
      Loading,
      t
    } = this.props;


    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          {t("EquipmentManagementScreenContent.Title")}
                        </h5>
                        <div
                          className="m-1 flex"
                          onClick={() => this.NewitemNav()}
                        >
                          <span className="mt-1 mdlabel">{t("ShipManagementContent.Add")}</span>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div
                          className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                        >
                          <label className="form-label">{t("ShipEquipmentStatusScreen.Equipment")}</label>
                          <br></br>
                          <Autocomplete
                            style={{ marginTop: "-12px" }}
                            noOptionsText={`${t("CommonText.NoOption")}`}
                            size={"small"}
                            value={EquipmentDropdownList.find(
                              (item) => item.id === this.state.searchData.EquipmentId
                            ) || null}
                            getOptionLabel={(item) => item?.name || ""}
                            options={EquipmentDropdownList ?? []}
                            onChange={(e, value) => this.onEquipmentChange(e, value?.id, value)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t("EquipmentManagementScreenContent.SelectEquipment")}
                                margin="normal"
                              />
                            )}
                          />
                        </div>
                        <div
                          className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                        >
                          <label className="form-label">{t("ComplianceandBudgetScreen.Type")}</label>
                          <br></br>
                          <Autocomplete
                            value={this.state.searchData.EquipmentType}
                            options={EquipmentTypeList ?? []}
                            style={{ marginTop: "-12px" }}
                            noOptionsText={t("CommonText.NoOption")}
                            size={"small"}
                            onChange={this.onTypeChange}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t("EditEquipmentScreenContent.SelectType")}
                                margin="normal"
                              />
                            )}
                          />
                          {/*   <Autocomplete
                              contentEditable={true}
                              open={!Loading ? this.state.openType : false}
                              onMenuVisibilityChange={(isOpen) => {
                                this.state.openType = isOpen;
                                this.setState({});
                              }}
                              value={this.state.searchData.EquipmentType}
                              inputProps={{ placeholder: "EquipmentType" }}
                              items={EquipmentTypeList ?? []}
                              getItemValue={(item) => item}
                              shouldItemRender={this.renderTypeTitle.bind(this)}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${
                                    isHighlighted ? "selected-items" : ""
                                  }`}
                                >
                                  {item}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChanges(e, "EquipmentType")
                              }
                              onSelect={(value, item) =>
                                this.handleSelectChange(value, "EquipmentType")
                              }
                            /> */}
                        </div>
                        <div
                          className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                        >
                          <label className="form-label">{t("TopPaneContent.Category")}</label>
                          <br></br>
                          {/*    <Autocomplete
                              contentEditable={true}
                              open={!Loading ? this.state.openCategoary : false}
                              onMenuVisibilityChange={(isOpen) => {
                                this.state.openCategoary = isOpen;
                                this.setState({});
                              }}
                              value={this.state.searchData.Category}
                              inputProps={{ placeholder: "Category" }}
                              items={CategoryList ?? []}
                              getItemValue={(item) => item}
                              shouldItemRender={this.renderCategoryTitle.bind(
                                this
                              )}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${
                                    isHighlighted ? "selected-items" : ""
                                  }`}
                                >
                                  {item}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChanges(e, "Category")
                              }
                              onSelect={(value, item) =>
                                this.handleSelectChange(value, "Category")
                              }
                            /> */}
                          <Autocomplete
                            value={this.state.searchData.Category}
                            options={CategoryList ?? []}
                            style={{ marginTop: "-12px" }}
                            noOptionsText={t("CommonText.NoOption")}
                            size={"small"}
                            onChange={this.onCategoryChange}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t("EquipmentManagementScreenContent.SelectCategory")}
                                margin="normal"
                              />
                            )}
                          />
                        </div>
                        <div
                          className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                        >
                          <label className="form-label">{t("ShipEquipmentStatusScreen.Capacity")} / {t("ShipEquipmentStatusScreen.Size")}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="capacity"
                            value={this.state.searchData.capacity}
                            placeholder={t("EquipmentManagementScreenContent.Capacity/Size")}
                            onChange={(e) =>
                              this.handleInputChanges(e, "capacity")
                            }
                            id="categorysize"
                          ></input>
                        </div>
                        <div
                          className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                        >
                          <label className="form-label">{t("ShipEquipmentStatusScreen.Make")}</label>
                          <br></br>
                          {/*    <Autocomplete
                              contentEditable={true}
                              open={!Loading ? this.state.openMake : false}
                              onMenuVisibilityChange={(isOpen) => {
                                this.state.openMake = isOpen;
                                this.setState({});
                              }}
                              value={this.state.searchData.Make}
                              inputProps={{ placeholder: "Make" }}
                              items={MakeList ?? []}
                              getItemValue={(item) => item.name}
                              shouldItemRender={this.renderMakeTitle.bind(this)}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${
                                    isHighlighted ? "selected-items" : ""
                                  }`}
                                >
                                  {item.name}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChanges(e, "Make")
                              }
                              onSelect={(value, item) =>
                                this.handleSelectChange(
                                  value,
                                  "Make",
                                  item.id,
                                  "MakeId"
                                )
                              }
                            /> */}
                          <Autocomplete
                            style={{ marginTop: "-16px" }}
                            noOptionsText={t("CommonText.NoOption")}
                            size={"small"}
                            value={MakeList.find(
                              (item) => item.id === this.state.searchData.MakeId
                            ) || null}
                            getOptionLabel={(item) => item.name || ""}
                            options={MakeList ?? []}
                            onChange={(e, value) =>
                              this.onMakeChange(e, value?.id, value)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t("MakeAndModelScreen.SelectMake")}
                                margin="normal"
                              />
                            )}
                          />
                        </div>
                        <div
                          className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                        >
                          <label className="form-label">{t("ShipEquipmentStatusScreen.Model")}</label>
                          <br></br>
                          <Autocomplete
                            style={{ marginTop: "-16px" }}
                            noOptionsText={t("CommonText.NoOption")}
                            size={"small"}
                            value={DropdownModelList.find(
                              (item) => item.id === this.state.searchData.ModelId
                            ) || null}
                            getOptionLabel={(item) => item.name || ""}
                            options={DropdownModelList ?? []}
                            onChange={(e, value) =>
                              this.onModelsChange(e, value?.id, value)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t("MakeAndModelScreen.SelectModel")}
                                margin="normal"
                              />
                            )}
                          />
                          {/*    <Autocomplete
                              contentEditable={true}
                              open={!Loading ? this.state.openModel : false}
                              onMenuVisibilityChange={(isOpen) => {
                                this.state.openModel = isOpen;
                                this.setState({});
                              }}
                              value={this.state.searchData.Model}
                              inputProps={{ placeholder: "Model" }}
                              items={DropdownModelList ?? []}
                              getItemValue={(item) => item.name}
                              shouldItemRender={this.renderModelTitle.bind(
                                this
                              )}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${
                                    isHighlighted ? "selected-items" : ""
                                  }`}
                                >
                                  {item.name}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChanges(e, "Model")
                              }
                              onSelect={(value, item) =>
                                this.handleSelectChange(
                                  value,
                                  "Model",
                                  item.id,
                                  "ModelId"
                                )
                              }
                            /> */}
                        </div>
                        <div
                          className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                        >
                          <label className="form-label">{t("content.Servicetype")}</label>
                          <br></br>
                          <Autocomplete
                            style={{ marginTop: "-12px" }}
                            noOptionsText={t("CommonText.NoOption")}
                            size={"small"}
                            value={DropdownServiceTypeList?.find(
                              (item) => item.item === this.state.searchData.ServiceTypeId
                            ) || null}
                            getOptionLabel={(item) => item.name || ""}
                            options={DropdownServiceTypeList ?? []}
                            onChange={(e, value) =>
                              this.onServiceTypeChanges(e, value?.item, value)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t("EquipmentManagementScreenContent.SelectServiceType")}
                                margin="normal"
                              />
                            )}
                          />
                          {/*    <Autocomplete
                              contentEditable={true}
                              open={
                                !Loading ? this.state.openServiceType : false
                              }
                              onMenuVisibilityChange={(isOpen) => {
                                this.state.openServiceType = isOpen;
                                this.setState({});
                              }}
                              value={this.state.searchData.ServiceType}
                              inputProps={{ placeholder: "Service Type" }}
                              items={applicableServiceTypeList ?? []}
                              getItemValue={(item) => item.name}
                              shouldItemRender={this.renderServiceTypeTitle.bind(
                                this
                              )}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${
                                    isHighlighted ? "selected-items" : ""
                                  }`}
                                >
                                  {item.name}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChanges(e, "ServiceType")
                              }
                              onSelect={(value, i) =>
                                this.handleSelectChange(
                                  value,
                                  "ServiceType",
                                  i.item,
                                  "ServiceTypeId"
                                )
                              }
                            /> */}
                        </div>
                        <div
                          className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                        >
                          <label className="form-label">{t("EquipmentTypeScreen.Title")}</label>
                          <br></br>
                          <Autocomplete
                            value={this.state.equipemntConfigTypeList?.find(
                              (item) => item.lookUpId === this.state.searchData.EquipmentCategoryId
                            ) || null}
                            options={this.state.equipemntConfigTypeList ?? []}
                            getOptionLabel={(item) => item.lookUpName || ""}
                            style={{ marginTop: "-12px" }}
                            noOptionsText={t("CommonText.NoOption")}
                            size={"small"}
                            onChange={(e, value) => this.onEquipmentTypeChange(e, value?.lookUpId, value)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t("EquipmentManagementScreenContent.SelectEquipmentType")}
                                margin="normal"
                              />
                            )}
                          />
                          {/*   <Autocomplete
                              contentEditable={true}
                              open={!Loading ? this.state.openType : false}
                              onMenuVisibilityChange={(isOpen) => {
                                this.state.openType = isOpen;
                                this.setState({});
                              }}
                              value={this.state.searchData.EquipmentType}
                              inputProps={{ placeholder: "EquipmentType" }}
                              items={EquipmentTypeList ?? []}
                              getItemValue={(item) => item}
                              shouldItemRender={this.renderTypeTitle.bind(this)}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${
                                    isHighlighted ? "selected-items" : ""
                                  }`}
                                >
                                  {item}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChanges(e, "EquipmentType")
                              }
                              onSelect={(value, item) =>
                                this.handleSelectChange(value, "EquipmentType")
                              }
                            /> */}
                        </div>
                        <div
                          className={
                            showSidePane
                              ? "col-lg-12 m-auto pt-3 pb-2"
                              : "col-lg-4 m-auto pt-3"
                          }
                        >
                          <div
                            className={
                              showSidePane
                                ? "search-btn-col"
                                : "pt-4 search-btn-col"
                            }
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchEquipment1(1)}
                            >
                              {t("content.Search")}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              {t("content.Clear")}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {EquipmentList ? (
                <EquipmentManagementCard
                  currentPage={(EquipmentList.pagination.currentPage - 1) * EquipmentList.pagination.pageSize}
                  arraylist={EquipmentList.data}
                  pageSize={EquipmentList.pagination.pageSize}
                  totalRecords={
                    EquipmentList.pagination.totalcount
                      ? EquipmentList.pagination.totalcount
                      : 0
                  }

                  setUpdatedState={(value) => this.SearchEquipment(value)}
                  eyeclick={(item) => this.eyeclick(item)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
  openEditScreen() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/EditEquipment");
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    EquipmentList: state.MasterScreenReducer.EquipmentList,
    EquipmentTypeList: state.MasterScreenReducer.DropdownEquipmentTypeList,
    equipmentSearch: state.MasterScreenReducer.equipmentSearch,
    CategoryList: state.MasterScreenReducer.DropdownCategoryList,
    DropdownServiceTypeList: state.MasterScreenReducer.DropdownServiceTypeList,
    Loading: state.PageLoaderReducer.loading,
    showSidePane: state.SidePanReducer.sidePan || false,
    MakeList: state.MasterScreenReducer.DropdownMakeList || [],
    DropdownModelList: state.MasterScreenReducer.DropdownModelList || [],
    List: state.MasterScreenReducer.DropdownServiceTypeList || [],
    EquipmentDropdownList:
      state.MasterScreenReducer.DropdownEquipmentList || [],
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EquipmentManagement)));
